module.exports = __webpack_public_path__ + "static/img/5.bc5060d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/5.png
// module id = PgLh
// module chunks = 1